/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';



import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faForwardStep } from '@fortawesome/free-solid-svg-icons/faForwardStep';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';


export default function Watch() {


  const nav = useNavigate();

  const { id } = useParams();

  const [search] = useSearchParams();

  const [type, setType] = useState('movie');
  const [season, setSeason] = useState(1);
  const [episode, setEpisode] = useState(1);
  const [maxEpisodes, setMaxEpisodes] = useState(1);
  const [data, setData] = useState();

  const [iframeSource, setIframeSource] = useState('');

  useEffect(() => {
    // Call getSource() and set the iframe source when the component mounts
    setIframeSource(getSource());
  }, []);

  function addViewed(data) {
    let viewed = [];

    const storage = localStorage.getItem('viewed');

    if (storage) {
      viewed = JSON.parse(storage);
    }

    const index = viewed.findIndex(v => v.id === data.id && v.type === data.type);

    if (index !== -1) {
      viewed.splice(index, 1);
    }

    viewed.unshift(data);
    viewed = viewed.slice(0, 15);

    localStorage.setItem('viewed', JSON.stringify(viewed));
  }

  function getSourceBackup() {
    // let url = `https://www.2embed.cc/embed/${id}`;
    // let url = `https://vidsrc.xyz/embed/${type}/${id}`;
    // let url = `https://vidsrc.su/embed/movie/${id}`
    // let url = `https://vidsrc.cc/v2/embed/movie/${id}`;
    // let url = `https://vidsrc.icu/embed/movie/${id}`;
    let url = `https://vidnest.fun/movie/${id}`;
    url += `?v=jkjk&n=hjhj`;

    url += `?v=${"3.2.0"}&n=${"Stream4City"}`;

    if (window.location.origin) url += `&o=${encodeURIComponent(window.location.origin)}`;
    // if (type === 'series') url = `https://vidsrc.xyz/embed/tv/${id}/${season}-${episode}`;
    if (type === 'series') url = `https://vidlink.pro/tv/${id}/${season}/${episode}`;
    // if (type === 'series') url = `https://www.2embed.cc/embedtv/${id}&s=${season}&e=${episode}`;

    // if (type === 'series') url = `https://vidsrc.icu/embed/tv/${id}/${season}/${episode}`;
    // if (type === 'series') url = `https://vidsrc.cc/v2/embed/tv/${id}/${season}/${episode}`;

    return url;
  }

  function getSource() {
    try {
      let url = `https://vidsrc.me/embed/${type}/${id}`;
      // let url = `https://api.rypr.ru/embed/${type}/${id}`;

      url += `?v=${"3.2.0"}&n=${"Stream4City"}`;

      if (window.location.origin) url += `&o=${encodeURIComponent(window.location.origin)}`;
      // if (type === 'series') url = `https://vidsrc.xyz/embed/tv/${id}/${season}-${episode}`;
      if (type === 'series') url = `https://api.rypr.ru/embed/series/${id}?s=${season}&e=${episode}`;

      return url;
    } catch (error) {
      console.error('Error occurred in getSource():', error);
      return getSourceBackup(); // Use backup function
    }
  }

  // new
  // function getSource2() {
  //   let url = `${import.meta.env.VITE_APP_API}/embed/${type}/${id}`;

  //   url += `?v=${import.meta.env.VITE_APP_VERSION}&n=${"Stream4City"}`;

  //   if (window.location.origin) url += `&o=${encodeURIComponent(window.location.origin)}`;
  //   if (type === 'series') url += `&s=${season}&e=${episode}`;

  //   return url;
  // }

  function getTitle() {
    let title = data ? data.title : '';

    if (type === 'series') title += ` S${season} E${episode}`;

    return title;
  }

  async function getData(_type) {
    // const req = await fetch(`${import.meta.env.VITE_APP_API}/${_type}/${id}`);
    // const res = await req.json();

    // if (!res.success) {
    //   return;
    // }

    const meData = await fetch(`https://api.themoviedb.org/3/${_type === 'series' ? 'tv' : 'movie'}/${id}?api_key=${"57240db50c2008e78c261e1a934627e4"}&language=en-US`);
    const meDataa = await meData.json();
    console.log(meDataa);

    // const data: Movie | Series = res.data;

    setData(data);

    addViewed({
      id: meDataa.id,
      poster_path: meDataa.poster_path,
      title: meDataa.title,
      media_type: _type === 'series' ? 'tv' : 'movie',
      type: _type
    });
  }

  async function getMaxEpisodes(season) {
    const response = await fetch(`https://api.themoviedb.org/3/tv/${id}/season/${season}?api_key=${"57240db50c2008e78c261e1a934627e4"}&language=en-US`);

    if (!response.ok) {
      throw new Error(`Failed to fetch episodes for show with ID`);
    }

    const data2 = await response.json();

    // const req = await fetch(`${import.meta.env.VITE_APP_API}/episodes/${id}?s=${season}`);
    // const res = await req.json();

    // if (!res.success) {
    //   nav('/');
    //   return;
    // }

    // const data = res.data;

    setMaxEpisodes(data2.episodes.length);
  }

  useEffect(() => {
    if (!data) return;
    if (!('seasons' in data)) return;

    if (season > data.seasons) {
      nav('/');
      return;
    }

    if (episode > maxEpisodes) {
      nav('/');
      return;
    }
  }, [data, maxEpisodes]);

  useEffect(() => {
    const s = search.get('s');
    const e = search.get('e');
    const me = search.get('me');

    if (!s || !e) {
      setType('movie');
      getData('movie');
      return;
    }

    setSeason(parseInt(s));
    setEpisode(parseInt(e));

    if (me) {
      setMaxEpisodes(parseInt(me));
    } else {
      getMaxEpisodes(parseInt(s));
    }

    setType('series');

    getData('series');

    localStorage.setItem(
      'continue_' + id,
      JSON.stringify({
        season: parseInt(s),
        episode: parseInt(e)
      })
    );
  }, [id, search]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {getTitle()} - {"Stream4City"}
        </title>
      </Helmet>

      <div className="player main">
        <div className="player-controls">
          <i onClick={() => nav(`/${type}/${id}`)}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </i>

          {type === 'series' && episode < maxEpisodes && (
            <i className="right" onClick={() => nav(`/watch/${id}?s=${season}&e=${episode + 1}&me=${maxEpisodes}`)}>
              <FontAwesomeIcon icon={faForwardStep} />
            </i>
          )}
        </div>

        <h2 className="player-title">{getTitle()}</h2>

        <iframe allowFullScreen referrerPolicy="origin" title={iframeSource} src={getSourceBackup()}></iframe>
      </div>
    </>
  );
}
